export const loadState = (itemKey: any) => {
	try {
		const serializedState = localStorage.getItem(itemKey)
		if (serializedState === null) {
			return undefined
		}
		return JSON.parse(serializedState)
	} catch (error) {
		return undefined
	}
}

export const saveState = (key: any, state: any) => {
	const serializedState = JSON.stringify(state)
	localStorage.setItem(key, serializedState)
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.ts